import { queryOptions } from '@tanstack/react-query';

import type { PaginatedApiFilters } from '@apple/utils/pagination/hooks/usePaginatedApi';

import type { StoreFilters } from '@apple/features/store/models/listing';

import {
	autocomplete,
	getAccessibleStoreList,
	getAccessibleStores,
	getActiveStores,
} from './api/listing';
import { getStore } from './api/management';

export const storeQueryKeys = {
	all: ['stores'],
	active: ['stores', 'active'],
	store: (storeId: string) => ['stores', storeId],
	accessible: () => ['stores', 'accessible'],
	accessibleList: () => [...storeQueryKeys.accessible(), 'list'],
	autocomplete: (search: string) => ['stores', 'autocomplete', search],
	paginatedList: (filters: PaginatedApiFilters<StoreFilters>) => [...storeQueryKeys.all, filters],
} as const;

export const storeQueries = {
	active: queryOptions({
		queryKey: storeQueryKeys.active,
		queryFn: ({ signal }) => getActiveStores(signal),
		initialDataUpdatedAt: 0,
		initialData: [],
	}),
	accessible: () =>
		queryOptions({
			queryKey: storeQueryKeys.accessible(),
			queryFn: ({ signal }) => getAccessibleStores(signal),
			initialDataUpdatedAt: 0,
			initialData: [],
		}),
	accessibleList: () =>
		queryOptions({
			queryKey: storeQueryKeys.accessibleList(),
			queryFn: ({ signal }) => getAccessibleStoreList(signal),
			initialDataUpdatedAt: 0,
			initialData: [],
		}),
	autocomplete: (search: string) =>
		queryOptions({
			queryKey: storeQueryKeys.autocomplete(search),
			queryFn: ({ signal }) => autocomplete(search, signal),
			initialDataUpdatedAt: 0,
			initialData: [],
		}),

	store: (storeId: string) =>
		queryOptions({
			queryKey: storeQueryKeys.store(storeId),
			queryFn: ({ signal }) => getStore(storeId, signal),
			initialDataUpdatedAt: 0,
		}),
} as const;
